<div class="global-loader-backdrop">
  <div class="loader-svg-wrapper">
    <svg class="chrome-loader" viewBox="25 25 50 50">
      <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke-width="4" />
    </svg>
    <div class="loader-text">Loading</div>
  </div>
</div>
